import { render, staticRenderFns } from "./ServiceJoinStep1Contentsogcbd.vue?vue&type=template&id=230edb09"
import script from "./ServiceJoinStep1Contentsogcbd.vue?vue&type=script&lang=js"
export * from "./ServiceJoinStep1Contentsogcbd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('230edb09')) {
      api.createRecord('230edb09', component.options)
    } else {
      api.reload('230edb09', component.options)
    }
    module.hot.accept("./ServiceJoinStep1Contentsogcbd.vue?vue&type=template&id=230edb09", function () {
      api.rerender('230edb09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/common/ServiceJoinStep1Contentsogcbd.vue"
export default component.exports